/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { AppContext } from 'shared/AppContext';
import { FONT_SYSTEM, tokens } from '../tokens';
import useIsMobile from '../useIsMobile';

// Form controls don't inherit font-family by default; the design sets
// input/button to the system stack globally, so mirror that for the subtree.
const Shell = styled.div`
  button,
  input,
  select,
  textarea {
    font-family: inherit;
  }
`;

// Outer page wrapper. Reads the app's theme toggle (AppContext.state.theme) and
// provides it to the entire v3 subtree via a styled-components ThemeProvider, so
// every v3 component follows light (Elevated) / dark. Also fills the content
// area, adds gutter padding (tighter on mobile), and caps + centers content.
const PageShell = ({ children, maxWidth = 1400 }) => {
  const ctx = useContext(AppContext);
  const name =
    ctx && ctx.state && ctx.state.theme === 'light' ? 'light' : 'dark';
  const t = tokens({ name });
  const isMobile = useIsMobile();
  return (
    <ThemeProvider theme={{ name }}>
      <Shell
        style={{
          minHeight: '100vh',
          boxSizing: 'border-box',
          padding: isMobile ? '16px 12px' : '32px 40px',
          background: t.page,
          fontFamily: FONT_SYSTEM,
          lineHeight: 1.5,
        }}
      >
        <div style={{ maxWidth, marginLeft: 'auto', marginRight: 'auto' }}>
          {children}
        </div>
      </Shell>
    </ThemeProvider>
  );
};

export default PageShell;
